export default "__VITE_ASSET__MN0ZT7LF__"